import { useContext } from "react";
import { PlatformAuthContext, type PlatformAuthState } from "../contexts/PlatformAuthContext";

export function usePlatformAuth(): PlatformAuthState {
  const ctx = useContext(PlatformAuthContext);
  if (!ctx) throw new Error("usePlatformAuth must be used inside <PlatformAuthProvider>");
  return ctx;
}
